import institutionAPI from 'services/institutionAPI'
import { CostCenterFilters } from 'InstitutionalManagement/types'

type Params = {
  filters: CostCenterFilters
}

export default async function readCostCentersOnCustomForm({ filters }: Params) {
  const response = await institutionAPI({
    method: 'POST',
    url: '/citizen-portal/service/cost-centers',
    data: filters,
  })

  return response
}
